import { useState, useEffect, createContext } from "react";

export const ConfigContext = createContext(null);

export default function ConfigProvider({ children }) {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const sleep = ms => new Promise(r => setTimeout(r, ms));

    const load = async () => {
      let retry = 0;
      while (!cancelled) {
        try {
          const res = await fetch("/config.json");
          if (!res.ok) throw new Error("Failed to load config");
          const data = await res.json();
          if (!cancelled) {
            setConfig(data);
            setLoading(false);
            setError(null);
          }
          return;
        } catch (e) {
          let err = e;
          if (err instanceof SyntaxError && typeof err.message === "string" && err.message.includes("<")) {
            err = new Error("missing config file");
          }

          if (++retry > 5)
          {
            console.warn("Loading config failed. Retrying...", {error: err});
            setError(err);
          }
          await sleep(1000);
        }
      }
    };

    load();
    return () => { cancelled = true };
  }, []);

  return (
    <ConfigContext.Provider value={{ config, configLoading: loading, configError: error }}>
      {children}
    </ConfigContext.Provider>
  );
};
